<div class="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
  <div class="flex items-center gap-3 w-full md:w-auto">
    <ng-container *ngIf="showHeaderFilters">

      <p-iconField *ngIf="isAdmin" class="max-w-sm w-full md:w-auto">
        <p-inputIcon
          [class]="loading ? 'pi pi-spin pi-spinner text-blue-500' : 'pi pi-search text-gray-500'"></p-inputIcon>
        <input type="text" pInputText [value]="searchTerm" (input)="globalSearch($event)" placeholder="Search"
          class="w-[150px] md:w-[200px] 2xl:w-[250px] h-[30px] !text-[13px] !py-0 border-gray-500 pr-8">
        <p-inputIcon *ngIf="searchTerm" class="pi pi-times cursor-pointer !text-gray-400 hover:!text-black"
          (click)="clearSearch()"></p-inputIcon>
      </p-iconField>

      <p-select [options]="statusOptions" [ngModel]="selectedStatus" (onChange)="onStatusChange($event.value)"
        [showClear]="true" placeholder="Status" optionLabel="label" optionValue="value"
        class="w-[150px] md:w-[200px] 2xl:w-[250px] h-[30px] !text-[13px] flex items-center border-gray-500">
      </p-select>

    </ng-container>
  </div>

  <div class="flex items-center gap-3 ml-auto">
    <ng-container *ngIf="showDateFilter">
      <div class="flex items-center gap-2">
        <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
          placeholder="Filter by Date Range" (onSelect)="onDateFilter()" [showIcon]="true" iconDisplay="input"
          appendTo="body" dateFormat="d MM, yy"
          inputStyleClass="h-[30px] text-[10px] font-semibold w-[260px] 2xl:w-[360px] border-gray-300 rounded-lg shadow-sm pl-[5.2rem]">

          <ng-template pTemplate="inputicon">
            <i class="pi pi-filter text-[11px] text-gray-500"></i>
          </ng-template>
        </p-datepicker>

        <button *ngIf="rangeDates" type="button" (click)="clearDateFilter()"
          class="text-[10px] text-red-500 hover:text-red-700 transition-colors font-medium">
          Reset
        </button>
      </div>
    </ng-container>

    <ng-content select="[header-action]"></ng-content>
  </div>
</div>

<p-table #dt
[value]="value"
[paginator]="paginator"
[rows]="rows"
[first]="(currentPage - 1) * rows"
[totalRecords]="totalRecords"
[globalFilterFields]="globalFilterFields"
(onPage)="onPageChange($event)"
[lazy]="lazy"
[lazyLoadOnInit]="false"
sortMode="single"
responsiveLayout="scroll"
class="custom-table"
(onLazyLoad)="onLazyLoadHandler($event)"
[alwaysShowPaginator]="true">

  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : undefined"
        class="!border-none !bg-white py-2 px-3">
        <div class="flex items-center justify-between w-full">
          <ng-container *ngIf="!headerCellTemplate; else customHeader">
            <typography variant="body-2" weight="semibold" color="text-black">
              {{ col.header }}
            </typography>
          </ng-container>
          <ng-template #customHeader>
            <ng-container *ngTemplateOutlet="headerCellTemplate; context: { $implicit: col }"></ng-container>
          </ng-template>
          <p-sortIcon *ngIf="col.sortable" [field]="col.field" class="scale-75"></p-sortIcon>
        </div>
      </th>
      <th *ngIf="actionTemplate" class="!border-none !bg-white text-center py-2">
        <typography variant="body-2" weight="semibold" color="text-black">
          Action
        </typography>

      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr [style.background-color]="rowIndex % 2 === 0 ? '#F8FAFC' : '#ffffff'" class="!border-none transition-colors">

      <td *ngFor="let col of columns" class="!border-none py-2 px-3">
        <ng-container *ngIf="!bodyCellTemplate; else customBodyCell">
          <ng-container [ngSwitch]="col.type">
            <span *ngSwitchCase="'date'" class="text-xs">{{ row[col.field] | date:'dd/MM/yyyy' }}</span>
            <span *ngSwitchDefault class="text-xs">{{ row[col.field] }}</span>
          </ng-container>
        </ng-container>
        <ng-template #customBodyCell>
          <ng-container *ngTemplateOutlet="bodyCellTemplate; context: { $implicit: row, col: col, rowIndex: rowIndex }"></ng-container>
        </ng-template>
      </td>

      <td *ngIf="actionTemplate" class="!border-none py-2 px-3 text-center" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="actionTemplate; context: { $implicit: row }">
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
